import { B2Form, B2Switch } from "@hdb/biome-2";

interface LayerDropdownComponentProps {
  showLabels: boolean;
  preventLabelOverlap: boolean;
  onToggleLabels: (checked: boolean) => void;
  onToggleLabelOverlap: (checked: boolean) => void;
}

const LayerDropdownComponent: React.FC<LayerDropdownComponentProps> = ({
  showLabels,
  preventLabelOverlap,
  onToggleLabels,
  onToggleLabelOverlap,
}) => {
  return (
    <div
      className="layer-dropdown shadow-lg"
      style={{
        position: "absolute",
        top: "2rem",
        right: 0,
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "0.75rem 1rem",
        width: "220px",
        zIndex: 9999,
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-semibold">Show Labels</span>
        <B2Form.Group>
          <B2Switch
            type="switch"
            name="showLabels"
            onChange={(e: any) => onToggleLabels(e.target.checked)}
            checked={showLabels}
            value={showLabels}
          />
        </B2Form.Group>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-2">
        <span className="fw-semibold">Prevent Overlap</span>
        <B2Form.Group>
          <B2Switch
            type="switch"
            name="preventLabelOverlap"
            onChange={(e: any) => onToggleLabelOverlap(e.target.checked)}
            checked={preventLabelOverlap}
            value={preventLabelOverlap}
            disabled={!showLabels}
          />
        </B2Form.Group>
      </div>
    </div>
  );
};

export default LayerDropdownComponent;
